import httpApiApplication from '@/app/http/httpApiApplication';

import { type TaxReturnSummary } from '../models/TaxReturn';

export const taxReturnService = {
  getTaxReturn: async (id: string): Promise<TaxReturnSummary> => {
    const response = await httpApiApplication.get<TaxReturnSummary>('/taxreturns/' + id);

    return response;
  },
  listMostRecentTaxReturns: async (): Promise<Array<TaxReturnSummary>> => {
    const response = await httpApiApplication.get<Array<TaxReturnSummary>>('/taxreturns/recent');

    return response;
  }
};
